import { BottomSheetState } from '@sc/data-access-models';

export function getTitle(bottomSheetState: BottomSheetState): string {
  switch (bottomSheetState) {
    case 'APPOINTMENT_FILTER':
      return 'refineSearch'; // dictionary key
    case 'CHOSE_NEW_ADDRESS':
    case 'GOOGLE_AUTO_COMPLETE':
      return 'yourAdress'; // dictionary key
  }
}
